import React, { createContext, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addParticipant, newMessageReceived, removeParticipant, setSocketConnectivity, engagementCreated } from '../redux/actions/chatActions';
import { createEngagement } from '../redux/actions/engagementActions';
import Socket from '../utils/socket';
import { RootState } from '../redux/store';

interface SocketContextProps {
    isSocketConnected: boolean;
    messages: any[];
    participants: any[];
    isBotConnected: boolean;
    engagementParam: any;
    socket: Socket | null;
}

export const SocketContext = createContext<SocketContextProps | undefined>(undefined);

const SocketContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [socket, setSocket] = useState<Socket | null>(null);
    const { user, chat } = useSelector((state: RootState) => state);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("user", user);  // Check if user data is loaded
        if (user?.user?.customerToken) {
            console.log("Customer Token Exists");
            Socket.refreshSocket();
            const instance = Socket.getInstance();
            setSocket(instance);
            dispatch(createEngagement({ sessionId: user.user.sessionId }));
        }
    }, [user?.user?.customerToken]);

    useEffect(() => {
        if (!socket) return;

        console.log("Socket Instance:", socket);

        const instance = Socket.getInstance();
        instance.removeAllListeners();

        instance.on('participantAdded', (message) => {
            dispatch(addParticipant(message));
        });

        instance.on('participantDisconnected', (message) => {
            dispatch(removeParticipant(message));
        });

        instance.on('message', (message) => {
            if(message.body.payload && message.senderParticipantType==="SYSTEM") {
                setTimeout(() => {
                  dispatch(newMessageReceived(message))
                }, 500);
              } else {
                dispatch(newMessageReceived(message))
              }
        
        });

        instance.on('engagementCreated', (message) => {
            dispatch(engagementCreated(message));
        });

        instance.on('connect', () => {
            dispatch(setSocketConnectivity(true));
            setSocket(instance);
        });

        instance.on('disconnect', () => {
            dispatch(setSocketConnectivity(false));
        });

        return () => {
            instance.off('participantAdded');
            instance.off('participantDisconnected');
            instance.off('message');
            instance.off('engagementCreated');
            instance.off('connect');
            instance.off('disconnect');
        };
    }, [socket, dispatch]);

    const contextValue:SocketContextProps = useMemo(() => ({
        isSocketConnected: chat.isSocketConnected,
        messages: chat.messages,
        participants: chat.participants,
        isBotConnected: chat.isBotConnected,
        engagementParam: chat.engagementParam,
        socket: socket
      }), [
        chat.isSocketConnected,
        chat.messages,
        chat.participants,
        chat.isBotConnected,
        chat.engagementParam,
        socket
      ]); 
    

    return (
        <SocketContext.Provider value={contextValue}>
            {children}
        </SocketContext.Provider>
    );
};

export default SocketContextProvider;
